import LazyImgwrapper from '@nexys/components/LazyImgWrapper/LazyImgWrapper'

export default LazyImgwrapper
